<template>
  <b-row class="justify-content-center my-5">
    <b-col cols="10" lg="6" class="sg-rounded-container">
      <b-row class="text-center">
        <b-col class="p-3">
          <b-img
            :src="require('@/assets/img/guider/happy-waving.png')"
            fluid
          />
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col cols="10">
          <h4>What's Next?</h4>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col cols="10">
          <h6>
            Kami perlu memastikan email yang dimasukan adalah benar email kamu. Silahkan cek pesan masuk di email yang baru saja kamu gunakan untuk mendaftar di StarGuides.
          </h6>
        </b-col>
      </b-row>

      <b-row class="mt-3" />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'Support_RegisterComplete'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Support/RegisterComplete.vue